import React from "react";

export function LinkedinIcon({ className }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.42528 2.49902C2.95881 2.49902 2 3.45601 2 4.71383C2 5.94387 2.93025 6.92814 4.36901 6.92814H4.39684C5.892 6.92814 6.82249 5.94387 6.82249 4.71383C6.79454 3.45601 5.892 2.49902 4.42528 2.49902Z"
        fill="currentColor"
      />
      <path d="M2.25 8.67871H6.53712V21.4966H2.25V8.67871Z" fill="currentColor" />
      <path
        d="M17.0649 8.38184C14.7521 8.38184 13.2013 10.5416 13.2013 10.5416V8.68267H8.91406V21.5006H13.2011V14.3426C13.2011 13.9594 13.229 13.5768 13.3423 13.3027C13.6522 12.5375 14.3575 11.7448 15.5419 11.7448C17.0932 11.7448 17.7136 12.9203 17.7136 14.6434V21.5006H22.0004V14.151C22.0004 10.2139 19.8853 8.38184 17.0649 8.38184Z"
        fill="currentColor"
      />
    </svg>
  );
}
